// Shared visual/config constants for the report charts (BarChart, LollipopChart).
// Kept in one place so both components stay in sync on breakpoints and colors.

import { Chart } from "chart.js";

// Chart.js draws all text (ticks, titles, tooltips) on canvas, so it never
// inherits the page's `font-family: Poppins` CSS - it must be set here.
// Setting the global default once means every chart that imports this
// module (BarChart, LollipopChart) picks it up without repeating `family`
// on each `font`/`ticks`/`title`/`tooltip` option object.
export const CHART_FONT_FAMILY = "Poppins, Helvetica, Arial, sans-serif";

Chart.defaults.font.family = CHART_FONT_FAMILY;

// Must match the CSS mobile breakpoint used across the app (see
// src/assets/styles/responsive/_index.scss `@media (max-width: 767px)`).
export const CHART_MOBILE_BREAKPOINT = 767;

// The user's own data point/bar is always this color, regardless of backend
// row order - never derived from array position or label text.
export const CHART_USER_COLOR = "#6941C6";

// Cycled by comparison-row index (i.e. index among non-user rows) so any
// number of comparison points (3, 5, 20+) each get a distinct-ish color.
export const CHART_COMPARISON_COLORS = ["#C7D7FE", "#A855F7", "#7A93FF", "#B38CFF", "#9E77ED"];

export const getComparisonColor = comparisonIndex => CHART_COMPARISON_COLORS[comparisonIndex % CHART_COMPARISON_COLORS.length];

export const isMobileViewport = () => typeof window !== "undefined" && window.innerWidth <= CHART_MOBILE_BREAKPOINT;
